import React from "react";
import { SiteType } from "../../types/api";
import { useSiteState } from "../../utils/useSiteState";
import { Link } from "react-router-dom";
import usePathname from "../../utils/usePathname";

interface SettingsRoute {
  title: string;
  children: {
    title: string;
    path: string;
    subtitle: string;
    condition?: (site: SiteType) => boolean;
  }[];
}
const settingsRoutes: SettingsRoute[] = [
  {
    title: "Details",
    children: [
      {
        title: "Metadata",
        path: "",
        subtitle: "Manage your projects metadata and SEO settings",
      },
      {
        title: "Domain",
        path: "/urls",
        subtitle: "Project domain and custom domain management",
      },
      {
        title: "Advanced",
        path: "/advanced",
        subtitle: "Additional settings and details for site",
      },
    ],
  },
  {
    title: "Design & Layout",
    children: [
      {
        title: "Menu",
        path: "/menu",
        subtitle: "",
      },
      {
        title: "Fonts & Colors",
        path: "/fonts-and-colors",
        subtitle: "",
      },
      {
        title: "Theme",
        path: "/theme",
        subtitle: "",
      },
    ],
  },
  {
    title: "Danger Zone",
    children: [
      {
        title: "Delete Project",
        path: "/delete",
        subtitle: "",
      },
      {
        title: "Transfer Project",
        path: "/transfer",
        subtitle: "",
      },
    ],
  },
];

interface MenuItemProps {
  title: string;
  to: string;
}
const SettingsSidebar: React.FC<any> = () => {
  const { site } = useSiteState();

  const pathname = usePathname();

  const MenuItem: React.FC<MenuItemProps> = ({
    title,
    to = `/${site.id}/settings`,
  }) => {
    const isActive = pathname === to.replace(/\/$/, "");
    return (
      <Link to={to}>
        <div
          className={`flex justify-start items-center group text-sm text hover:text-white transition ease-in-out duration-150 py-1 ${
            isActive ? "text-primary" : "text-gray-450"
          }`}
        >
          {title}
        </div>
      </Link>
    );
  };

  return (
    <div className="w-2/12 max-w-sm bg-gray-750 flex-shrink-0 flex-grow-0 h-screen rounded-r-xl shadow p-10">
      <h1 className="text-xl mb-6">Settings</h1>

      {settingsRoutes.map((group: SettingsRoute, groupIndex: number) => (
        <div key={groupIndex}>
          <h4 className="text-sm font-medium text-gray-300">{group.title}</h4>
          {group.children
            .filter((rt) => !rt.condition || rt.condition(site))
            .map((route, index) => (
              <MenuItem
                key={index}
                to={`/${site.id}/settings${route.path}`}
                title={route.title}
              />
            ))}
          <br />
        </div>
      ))}
    </div>
  );
};

export default SettingsSidebar;
